import BaseController from "./base"

export default class extends BaseController {
  connect() {
    this.initializeTomSelect()
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.placeholderInterval) {
      clearInterval(this.placeholderInterval)
    }
  }

  initializeTomSelect() {
    if (typeof TomSelect !== 'undefined') {
      const tomSelectInstance = this
      
      this.tomSelect = new TomSelect(this.element, {
        allowEmptyOption: true,
        placeholder: 'Search to add a Role',
        searchField: ['text'],
        highlight: false,
        maxItems: 1,
        plugins: {},
        create: false,
        dropdownParent: 'body',
        onInitialize: function() {
          this.clear(true);
          this.setValue('', true);
          
          // Force set placeholder
          tomSelectInstance.setPlaceholder(this);
        },
        onFocus: function() {
          if (!this.getValue()) {
            tomSelectInstance.setPlaceholder(this);
          }
        },
        onChange: function(value) {
          if (value) {
            setTimeout(() => {
              this.clear(true);
              tomSelectInstance.setPlaceholder(this);
            }, 100)
          }
        },
        render: {
          option: function(data, escape) {
            return '<div>' + escape(data.text) + '</div>';
          },
          item: function(data, escape) {
            return '<div>' + escape(data.text) + '</div>';
          },
          optgroup_header: function(data, escape) {
            return '<div class="optgroup-header">' + escape(data.label) + '</div>';
          }
        }
      })
      
      // Use MutationObserver to continuously set placeholder
      this.setupPlaceholderObserver()
      
    } else {
      setTimeout(() => this.initializeTomSelect(), 100)
    }
  }

  setPlaceholder(tomSelectInstance) {
    // Try multiple approaches to set the placeholder
    const input = tomSelectInstance.control_input.querySelector('input');
    if (input) {
      input.placeholder = 'Search to add a Role';
      input.setAttribute('placeholder', 'Search to add a Role');
    }
    
    // Also try setting it on the control_input itself
    tomSelectInstance.control_input.placeholder = 'Search to add a Role';
    
    // Force update of the control
    if (tomSelectInstance.settings) {
      tomSelectInstance.settings.placeholder = 'Search to add a Role';
    }
  }

  setupPlaceholderObserver() {
    // Wait for TomSelect to create the input element
    setTimeout(() => {
      const input = this.element.parentElement.querySelector('input[id^="tomselect-"]');
      if (input) {
        // Set placeholder immediately
        input.placeholder = 'Search to add a Role';
        input.setAttribute('placeholder', 'Search to add a Role');
        
        // Create observer to watch for changes
        this.observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'placeholder') {
              if (input.placeholder !== 'Search to add a Role') {
                input.placeholder = 'Search to add a Role';
                input.setAttribute('placeholder', 'Search to add a Role');
              }
            }
          });
        });
        
        // Observe placeholder changes
        this.observer.observe(input, {
          attributes: true,
          attributeFilter: ['placeholder']
        });
        
        // Also set up periodic check
        this.placeholderInterval = setInterval(() => {
          if (input.placeholder !== 'Search to add a Role' && !input.value) {
            input.placeholder = 'Search to add a Role';
            input.setAttribute('placeholder', 'Search to add a Role');
          }
        }, 500);
      }
    }, 300);
  }
}